export default {
    install(Vue) {
        Vue.filter('formatZhDate', function(value) {
            if (!value) return ''

            // 处理 ISO 8601 时间字符串
            const date = new Date(value)

            // 获取中国时区时间（UTC+8）
            const chinaTime = new Date(date.getTime() + 8*3600*1000)

            // 格式化输出
            const year = chinaTime.getUTCFullYear()
            const month = String(chinaTime.getUTCMonth() + 1).padStart(2, '0')
            const day = String(chinaTime.getUTCDate()).padStart(2, '0')

            return `${year}年${month}月${day}日`
        });
    }
};